import { IComponentController } from "angular";
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IPaginationClass } from "../../../../../core/services/pagination.service";

interface IPagePb0015 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Pb0015Controller(   Pagination: IPaginationClass) {
    const vm: IPagePb0015 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            pagination: true,
            suiviModification: false,
            rechercheCollapsable: false,
            edition: false,
            supprime:false
        },
        pagination: new Pagination({
            nombreElementPage: 50,
            nbElementsPossibles: [50, 100, 150]
        }),
        colonnesVisibles: [
            { nom: 'cbmmsg', largeur: 120 }
        ]
    };
}